import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

class SelectInput extends React.Component {
  render() {
    const { options, idKey, nameKey, ...props } = this.props;
    return (
      <Select {...props}>
        {options.map(item => (
          <Select.Option key={item[idKey]} value={item[idKey]}>
            {item[nameKey]}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

SelectInput.defaultProps = {
  idKey: 'id',
  nameKey: 'name',
};

SelectInput.propTypes = {
  nameKey: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  idKey: PropTypes.string,
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/common/DataEntry/SelectInput/index.js